<div class="container-fluid rmus-root">
  <app-card-analytics [stats]="stats" (shareFilterValue)="onFilterBy($event)">
  </app-card-analytics>

    <div class="table-root">
      <div class="table-action-wrapper d-flex align-items-center justify-content-between">
        <div id="rmu_search" class="search-input">
          <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText" (keydown.enter)="search()"
            (ngModelChange)="this.searchTextUpdate.next($event)" />
        </div>
        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div id="rmu_date-type" class="datetype-picker">
                <div class="dropdown" (click)="showSelectDateType = !showSelectDateType" click-stop-propagation
                  [title]="selectedDateTypeDisplay | translate">
                  <span>{{'COMMON.DATE_TYPE.TITLE' | translate}}:</span>
                  <span>{{ selectedDateTypeDisplay | translate }}</span>
                  <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
                </div>
                <div class="dropdown-opened" *ngIf="showSelectDateType">
                  <div
                  [id]="'rmu_date-type-' + (i + 1)"
                  (click)="
                      selectDateType(dateType); (datesValid() == true && (dateTo || dateFrom)) && search()
                    " *ngFor="let dateType of dateTypes; let i = index">
                    <div>{{ dateType.translation | translate }}</div>
                  </div>
                </div>
              </div>
              <div id="rmu_date-from" class="datepicker-container" style="width: 23rem;">
                <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
                <input type="date" id="dateFrom" name="dateFrom" [ngClass]="
                    !datesValid()
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  " [(ngModel)]="dateFrom" (change)="datesValid() == true && search()" />
              </div>

              <div id="rmu_date-to" class="datepicker-container">
                <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
                <input type="date" id="dateTo" name="dateTo" [ngClass]="
                    !datesValid()
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  " [(ngModel)]="dateTo" (change)="datesValid() == true && search()" />
              </div>
            </div>
          </div>
          <div id="rmu_sort-by" class="sort-by-root" (click)="showSortBy = !showSortBy" click-stop-propagation>
            <div class="dropdown" [title]="sortByName | translate">
              <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
              <span>{{ sortByName | translate }}</span>
              <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showSortBy">
              <div id="rmu_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">{{'COMMON.SORT_BY.NEWEST' | translate}}</div>
              <div id="rmu_sort-by-slrn-asc" (click)="sortBy(sortByOptions.SLRN_ASC)">{{'COMMON.SORT_BY.SLRN_ASC' | translate}}.</div>
              <div id="rmu_sort-by-slrn-desc" (click)="sortBy(sortByOptions.SLRN_DESC)">{{'COMMON.SORT_BY.SLRN_DESC' | translate}}.</div>
              <div id="rmu_sort-by-id" (click)="sortBy(sortByOptions.ID)">ID</div>
            </div>
          </div>

          <button class="btn btn-icon" (click)="download()">
            <span>{{'COMMON.DOWNLOAD' | translate}}</span>
          </button>
          <div>
            <button class="btn btn-primary btn-upload" (click)="showUpload = !showUpload" click-stop-propagation>
              <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
            </button>
            <div *ngIf="showUpload" class="xlsx-upload" [routerLink]="'/upload/4/' + utilityId">
              <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
              <div>{{'COMMON.UPLOAD_XLSX' | translate}}</div>
            </div>
          </div>
          <button class="btn btn-primary btn-add-new" routerLink="add">
            <img src="../../assets/icons/plus.svg" alt="Plus icon" />
            <span style="white-space: nowrap;">{{'RMU.NEW_RMU' | translate}}</span>
          </button>
        </div>
      </div>
      <div class="filter">
        <div class="filter-list">
          {{'COMMON.FILTER' | translate}}
          <app-multi-select-dropdown [id]="'rmu_region_filter'" class="multiselect" [clicked]="clicked" [items]="regions" [label]="'COMMON.BU.PLURAL'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectRegion($event)">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown [id]="'rmu_area_filter'" class="multiselect" [clicked]="clicked" [items]="areas" [label]="'COMMON.UT.PLURAL'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectArea($event)">
          </app-multi-select-dropdown>

          <select id="rmu_user-type_filter" name="st-select" (change)="selectUserType($event)" class="form-select">
            <option value="" [selected]="!userType" disabled>
              {{'COMMON.USER.TYPE.TITLE' | translate}}
            </option>
            <option [id]="'rmu_user-type_filter-' + (i + 1)" [selected]="userType == o.value" *ngFor="let o of userTypeOptions; let i = index" value="{{ o.value }}">
              {{ o.translation | translate }}
            </option>
          </select>

          <app-multi-select-dropdown [id]="'rmu_user_filter'" class="multiselect" [searchFilterActive]="true"
            (filterValue)="applySearchFilter($event)" [clicked]="clicked" [items]="filteredUsers" [label]="'COMMON.USER.PLURAL'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectUsers($event)">
          </app-multi-select-dropdown>

          <select id="rmu_type_filter" name="rmu-type-select" (change)="selectRmuType($event)" class="form-select">
            <option value="" [selected]="!rmuType" disabled>
              {{'RMU.TYPE' | translate}}
            </option>
            <option [id]="'rmu_user-type_filter-' + (i + 1)" [selected]="rmuType == o.value" *ngFor="let o of rmuTypeOptions; let i = index" value="{{ o.value }}">
              {{ o.translation | translate }}
            </option>
          </select>

          <select id="rmu_status_filter" name="rmu-status-select" (change)="selectRmuStatus($event)" class="form-select">
            <option value="" [selected]="!rmuStatus" disabled>
              {{'RMU.STATUS' | translate}}
            </option>
            <option [id]="'rmu_status_filter-' + (i + 1)" [selected]="rmuStatus == o.value" *ngFor="let o of rmuStatusOptions; let i = index" value="{{ o.value }}">
              {{ o.translation | translate }}
            </option>
          </select>

          <select id="rmu_validation-status_filter" *ngIf="permissionsService.isValidationStatusAllowed" name="status" (change)="selectStatus($event)" class="form-select">
            <option value="0" [selected]="status == 0" disabled>{{'COMMON.VALIDATION_STATUS' | translate}}</option>
            <option [id]="'rmu_validation-status_filter-' + (i + 1)" [selected]="status == o.value" *ngFor="let o of statusOptions; let i = index" value="{{ o.value }}">
              {{ o.translation | translate }}
            </option>
          </select>

        </div>

        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist [filters]="selectedFilters" [useApply]="true" (resetFilterEmitter)="resetFilter($event)"
            (removeFilterEmitter)="removeFilter($event)" (applyFilterEmitter)="applyFilter()">
          </app-filter-checklist>
        </div>
      </div>
      <div class="table">
        <div *ngIf="rmus">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="rmu_table_header_checkbox">
                  <input type="checkbox" class="form-check-input" [ngModel]="allCheckboxesChecked"
                    (click)="checkAllCheckboxes()" />
                </th>
                <th id="rmu_table_header_slrn">{{'COMMON.SLRN' | translate}}</th>
                <th id="rmu_table_header_type">{{'RMU.TYPE' | translate}}</th>
                <th id="rmu_table_header_voltage-level">{{'RMU.VOLTAGE_LEVEL' | translate}}</th>
                <th id="rmu_table_header_status">{{'RMU.STATUS' | translate}}</th>
                <th id="rmu_table_header_feeder-voltage">{{'RMU.FEEDER_VOLTAGE' | translate}}</th>
                <th id="rmu_table_header_feeder-name">{{'RMU.FEEDER_NAME' | translate}}</th>
                <th id="rmu_table_header_rmu-address" class="th-address">{{'RMU.ADDRESS' | translate}}</th>
                <th id="rmu_table_header_district">{{'COMMON.UT.SINGLE' | translate}}</th>
                <th id="rmu_table_header_region">{{'COMMON.BU.SINGLE' | translate}}</th>
                <th id="rmu_table_header_validation-status" *ngIf="permissionsService.isValidationStatusAllowed">{{'COMMON.VALIDATION_STATUS' | translate}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'rmu_table_row-' + (i + 1)" *ngFor="let rmu of rmus; let i = index">
                <td [id]="'rmu_table_checkbox-' + (i + 1)">
                  <input type="checkbox" class="form-check-input" value="{{ rmu.id }}" [ngModel]="rmu.checked"
                    (click)="checkRmu(rmu.id)" />
                </td>

                <td [id]="'rmu_table_slrn-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu?.slrn | hasValue }}
                </td>

                <td [id]="'rmu_table_type-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.type | hasValue }}
                </td>

                <td [id]="'rmu_table_voltage-level-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.voltageLevel.toString() == "KV11" ? "11kV" : ("33kV" | hasValue) }}
                </td>

                <td [id]="'rmu_table_status-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.status | hasValue }}
                </td>

                <td [id]="'rmu_table_feeder-voltage-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.feederVoltage.toString() == "KV11" ? "11kV" : ("33kV" | hasValue) }}
                </td>

                <td [id]="'rmu_table_feeder-name-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.feederName | hasValue }}
                </td>

                <td [id]="'rmu_table_rmu-address-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.locationAddress | hasValue }}
                </td>

                <td [id]="'rmu_table_district-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.area | hasValue }}
                </td>

                <td [id]="'rmu_table_region-' + (i + 1)" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  {{ rmu.region | hasValue }}
                </td>

                <td [id]="'rmu_table_validation-status-' + (i + 1)" *ngIf="permissionsService.isValidationStatusAllowed" [routerLink]="['edit', rmu.id]" (click)="setFilterStorage()">
                  <div *ngIf="rmu.validationStatus" class="building-status" [ngClass]="{
                          'complete-building' : rmu.validationStatus == 'Approved',
                          'rejected-building' : rmu.validationStatus == 'Rejected'
                        }">
                    {{ rmu.validationStatus == 'Approved' ? ('COMMON.ASSET_STATUS.COMPLETE' | translate) : ('COMMON.ASSET_STATUS.REJECTED' | translate) }}
                  </div>
                  <div *ngIf="rmu.status && !rmu.validationStatus" class="building-status" [ngClass]="{
                      'pending-building': rmu.assetStatus == 'Pending',
                      'assigned-building': rmu.assetStatus == 'Assigned' || rmu.assetStatus == 'Retagged'
                    }">
                    {{ 'COMMON.ASSET_STATUS.' + rmu.assetStatus | uppercase | translate }}
                  </div>
                  <div *ngIf="!rmu.status && !rmu.validationStatus" class="building-status">--------</div>
                </td>
                <td class="more-icon" (click)="setFilterStorage()" [routerLink]="['edit', rmu.id]">
                  <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <app-paging *ngIf="count > 0" [pageSize]="pageSize" [useDirect]="true" [count]="count"
              [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-paging>
          </div>
        </div>
      </div>
    </div>
</div>

